import * as actionTypes from "constants/actionTypes";

export const updateProfileAttributeAndFlushProfileAttribute = (
  attributeId,
  changes
) => {
  return {
    type: actionTypes.UPDATE_PROFILE_ATTRIBUTE_AND_FLUSH_PROFILE_ATTRIBUTE,
    payload: {
      attributeId,
      changes
    }
  };
};

export const replaceAccountProfileAttributes = attributes => {
  return {
    type: actionTypes.REPLACE_ACCOUNT_PROFILE_ATTRIBUTES,
    payload: {
      attributes
    }
  };
};

export const replaceAccountProfileAttribute = (attribute, attributeId) => {
  return {
    type: actionTypes.REPLACE_ACCOUNT_PROFILE_ATTRIBUTE,
    payload: {
      attribute,
      attributeId
    }
  };
};

export const deleteAccountProfileAttributeInStore = profileAttributeId => {
  return {
    type: actionTypes.DELETE_ACCOUNT_PROFILE_ATTRIBUTE_IN_STORE,
    payload: {
      profileAttributeId
    }
  };
};
